import React from 'react'

import { HeaderTag } from '../types'
import { Badge } from '@/Atomic/Atoms/Badge'
import { getVariantForGroup } from '@/utils/enumGroupVariant'

interface HeaderTagsProps {
  tags?: HeaderTag[]
}

export const HeaderTags: React.FC<HeaderTagsProps> = ({ tags }) => {
  return (
    <div className="tags">
      {tags?.map((tag) => (
        <div className="tag" key={tag.key}>
          <div className="key">{tag.key}</div>
          <div className="values">
            {tag.values.map(({ label, enumGroup }, index) => (
              <Badge
                key={`${label}-${enumGroup ?? index}`}
                value={label}
                variant={getVariantForGroup(enumGroup)}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
